import { createChildListViewContainer } from 'factories/ChildListView'
import Component from 'components/Jobs/Labour'

export default createChildListViewContainer()(Component)
